import { backendFetch } from '../apiUtils';
import { normalizeStatusListResponse } from './load';

/** Unified EPO loads lazy search (POST /v2/EPO/searchLazy). */
export const postUnifiedEpoSearchLazy = async (payload) => {
  const response = await backendFetch({
    url: 'v2/EPO/searchLazy',
    method: 'POST',
    options: {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
    authorised: true,
  });

  if (response?.success === false) {
    throw new Error(response.message || 'Failed to load unified EPO loads.');
  }

  if (response?.totalItems != null || Array.isArray(response?.data)) {
    return response;
  }

  return response?.data ?? response;
};

export const postEpoHeaders = async (formData) => {
  const { data } = await backendFetch({
    url: 'v2/EPO/Headers',
    method: 'POST',
    options: { body: formData },
  });
  return data;
};

export const getEPOStatusesV2 = async () => {
  const response = await backendFetch({
    url: 'v2/EPO/status',
    method: 'GET',
    authorised: true,
  });

  if (response?.success === false) {
    throw new Error(response.message || 'Failed to load EPO statuses.');
  }

  return normalizeStatusListResponse(response);
};

export const updateEPOStatus = async (loadId, status) => {
  const documentResponse = await backendFetch({
    url: `v2/EPO/status`,
    options: {
      body: JSON.stringify({
        id: loadId,
        status,
      }),
      headers: { 'Content-Type': 'application/json' },
    },
    method: 'PUT',
  });
  return documentResponse.data;
};

export const getEpoForms = async (id) => {
  const response = await backendFetch({
    url: 'v2/EPO/forms',
    params: { id },
  });

  return response.data;
};

export const postEPOMovementDirection = async (formData) => {
  const { data } = await backendFetch({
    url: 'v2/EPO/epoMovementDirection',
    method: 'POST',
    options: { body: formData },
  });
  return data;
};

export const getEPOList = async (id) => {
  const { data } = await backendFetch({
    url: 'v2/EPO/List',
    params: { id },
  });
  return data;
};

export const getLspTraders = async () => {
  const { data } = await backendFetch({
    url: 'v2/EPO/lspTraders',
  });
  return data;
};

export const validateRoute = async (formData) => {
  const { data } = await backendFetch({
    url: 'v2/EPO/validateRoute',
    method: 'POST',
    options: { body: formData },
  });

  return data;
};
